import {ENDPOINT_SEARCH} from 'common/endpoints';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import {commonJwtHeader, removeEmptyIds} from 'common/utils';

const _ = require('lodash');

const GRANTS_BULK_LIMIT = 200;
const APPLICATION_RANK_LIMIT = 10000;
const SUBGRANTS_LIMIT = 1000;

const getSubAppsByTitle = (
  token,
  organizationId,
  programId,
  subAppTypes,
  entityId,
  value
) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&subAppTypes=${subAppTypes}` +
    `&selector=add_subapplication_template` +
    `&applicationId=${entityId}` +
    `&operation=match_phrase_prefix&field=payload.applicationTitle` +
    `&value=${value}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubapplicant = (
  token,
  organizationId,
  programId,
  subAppTypes,
  entityId,
  subAppId
) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&subAppTypes=${subAppTypes}` +
    `&selector=add_subapplication_template` +
    `&applicationId=${entityId}` +
    `&operation=match&field=subOrgId` +
    `&value=${subAppId}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByOrgId = (token, organizationId, programId, submittedBy) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getMyGrants = (token, organizationId, limit = GRANTS_BULK_LIMIT) => {
  let tokenValue = token;
  tokenValue = token._csrftoken;
  let query =
    `organizationId=${organizationId}` +
    `&token=${tokenValue}` +
    `&selector=get_grantsByBulk` +
    `&limit=${limit}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByOrgIdAndByCategoryId = (
  token,
  organizationId,
  orgId,
  parentOrgIds,
  categoryId,
  submittedBy
) => {
  let query =
    `organizationId=${organizationId}` +
    `&categoryId=${categoryId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRecipientSavedForLater = (
  token,
  {limit, offset, sort, order, organizationId}
) => {
  let tokenValue = token;
  tokenValue = token._csrftoken;
  let query =
    `&organizationId=${organizationId}` +
    `&selector=get_recipient_saved_for_later_list` +
    `&userId=${token.userId}` +
    `&limit=${limit}` +
    `&offset=${offset}` +
    `&sort=${sort}` +
    `&order=${order}` +
    `&token=${tokenValue}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getSubAppsByOrgIdAndByProgramId = (
  token,
  organizationId,
  orgId,
  parentOrgIds,
  programId,
  submittedBy
) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubGrantsByOrgId = (
  token,
  organizationId,
  orgId,
  parentOrgIds,
  submittedBy,
  limit = SUBGRANTS_LIMIT
) => {
  let query =
    `organizationId=${organizationId}` +
    `&selector=get_subgrants` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}` +
    `&limit=${limit}`;
  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubOrgIdAndByCategoryId = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  categoryId,
  submittedBy
) => {
  let query =
    `organizationId=${organizationId}` +
    `&subOrgId=${subOrgId}` +
    `&categoryId=${categoryId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubOrgIdAndByProgramId = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  programId,
  submittedBy
) => {
  let query =
    `organizationId=${organizationId}` +
    `&subOrgId=${subOrgId}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubGrantsBySubOrgId = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  submittedBy,
  limit = SUBGRANTS_LIMIT
) => {
  let query =
    `organizationId=${organizationId}` +
    `&subOrgId=${subOrgId}` +
    `&selector=get_subgrants` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}` +
    `&limit=${limit}`;
  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubOrgIdAndOrgIdListAndByCategoryId = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  categoryId,
  submittedBy
) => {
  let query =
    `subOrgId=${subOrgId}` +
    `&organizationId=${removeEmptyIds(parentOrgIds)}` +
    `&categoryId=${categoryId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubOrgIdAndOrgIdListAndByProgramId = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  programId,
  submittedBy
) => {
  let query =
    `subOrgId=${subOrgId}` +
    `&organizationId=${removeEmptyIds(parentOrgIds)}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubGrantsBySubOrgIdAndOrgIdList = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  submittedBy,
  limit = SUBGRANTS_LIMIT
) => {
  let query =
    `subOrgId=${subOrgId}` +
    `&organizationId=${removeEmptyIds(parentOrgIds)}` +
    `&selector=get_subgrants` +
    `&operation=match&field=payload.applicationSubmittedFor.keyword&value=${submittedBy}` +
    `&limit=${limit}`;
  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubOrgIdAndOrgIdListAndByCategoryIdBothSelfAndApplicant = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  categoryId,
  submittedBy
) => {
  let query =
    `organizationId=${organizationId}` +
    `&subOrgId=${subOrgId}` +
    `&organizationId=${removeEmptyIds(parentOrgIds)}` +
    `&categoryId=${categoryId}` +
    `&selector=get_subapplications` +
    `&operation=query_string&field=query&value=payload.applicationSubmittedFor.keyword:self OR payload.applicationSubmittedFor.keyword:applicant`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsBySubOrgIdAndOrgIdListAndByProgramIdBothSelfAndApplicant = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  programId,
  submittedBy
) => {
  let query =
    `organizationId=${organizationId}` +
    `&subOrgId=${subOrgId}` +
    `&organizationId=${removeEmptyIds(parentOrgIds)}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=query_string&field=query&value=payload.applicationSubmittedFor.keyword:self OR payload.applicationSubmittedFor.keyword:applicant`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubGrantsBySubOrgIdAndOrgIdListBothSelfAndApplicant = (
  token,
  organizationId,
  subOrgId,
  parentOrgIds,
  submittedBy,
  limit = SUBGRANTS_LIMIT
) => {
  let query =
    `organizationId=${organizationId}` +
    `&subOrgId=${subOrgId}` +
    `&organizationId=${removeEmptyIds(parentOrgIds)}` +
    `&selector=get_subgrants` +
    `&operation=query_string&field=query&value=payload.applicationSubmittedFor.keyword:self OR payload.applicationSubmittedFor.keyword:applicant` +
    `&limit=${limit}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubGrantsBySubOrgIdAndOrgIdAndFoIdAndStatus = ({
  subOrgId,
  organizationId,
  fundingOpportunityId,
  status,
  limit = SUBGRANTS_LIMIT,
}) => {
  let query =
    `subOrgId=${subOrgId}` +
    `&organizationId=${organizationId}` +
    `&fundingOpportunityId=${fundingOpportunityId}` +
    `&status=${status}` +
    `&selector=get_subgrants` +
    `&operation=query_string&field=query&value=payload.applicationSubmittedFor.keyword:self OR payload.applicationSubmittedFor.keyword:applicant` +
    `&limit=${limit}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByOrgIdAndType = (token, organizationId, programId, type) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationType&value=${type}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByOrgIdByTypeAndByCategoryId = (
  token,
  organizationId,
  categoryId,
  type
) => {
  let query =
    `organizationId=${organizationId}` +
    `&categoryId=${categoryId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=payload.applicationType&value=${type}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByOrgIdAndSubOrgId = (token, organizationId, programId, subOrgId) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=subOrgId&value=${subOrgId}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByOrgIdBySubOrgIdAndByCategoryId = (
  token,
  organizationId,
  categoryId,
  subOrgId
) => {
  let query =
    `organizationId=${organizationId}` +
    `&categoryId=${categoryId}` +
    `&selector=get_subapplications` +
    `&operation=match&field=subOrgId&value=${subOrgId}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubAppsByType = (
  token,
  organizationId,
  programId,
  subAppTypes,
  entityId,
  type
) => {
  let query =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&subAppTypes=${subAppTypes}` +
    `&selector=add_subapplication_template` +
    `&applicationId=${entityId}` +
    `&operation=match&field=payload.applicationType` +
    `&value=${type}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getPaginatedEntitiesForFo = (
  entityType,
  foId,
  programId,
  limit,
  order,
  offset,
  statuses,
  sort,
  term,
  hideColumns,
  organizationId = null,
  organizationIds = null,
  selector = 'get_paginated_entities_for_funding_opportunity'
) => {
  return fetch(
    `${ENDPOINT_SEARCH}?entityType=${entityType}&fundingOpportunityId=${foId}&programId=${programId}&selector=${selector}&limit=${limit}&order=${order}&offset=${offset}${
      statuses ? `&statuses=${statuses}` : ''
    }${sort ? `&sort=${sort}` : ''}${
      organizationId ? `&organizationId=${organizationId}` : ''
    }${organizationIds ? `&organizationIds=${organizationIds}` : ''}${
      term
        ? `&term=${encodeURIComponent(term)}${
            hideColumns ? `&hideColumns=${hideColumns}` : ''
          }`
        : ''
    }`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getPaginatedSubApps = (
  foId,
  programId,
  orgId,
  organizationIds,
  selector,
  limit,
  order,
  offset,
  statuses,
  sort,
  term,
  hideColumns
) => {
  return fetch(
    `${ENDPOINT_SEARCH}?fundingOpportunityId=${foId}&programId=${programId}&organizationId=${orgId}&selector=${selector}&limit=${limit}&order=${order}&offset=${offset}${
      statuses ? `&statuses=${statuses}` : ''
    }${organizationIds ? `&organizationIds=${organizationIds}` : ''}${
      sort ? `&sort=${sort}` : ''
    }${
      term
        ? `&term=${encodeURIComponent(term)}${
            hideColumns ? `&hideColumns=${hideColumns}` : ''
          }`
        : ''
    }`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getPaginatedSubAppsForFo = (
  foId,
  programId,
  limit,
  order,
  offset,
  statuses,
  sort,
  term,
  hideColumns,
  selector
) => {
  let subappSelector =
    selector === 'get_paginated_subapplications_by_subgrant_status'
      ? 'get_paginated_subapps_by_subgrant_status_for_fo'
      : 'get_paginated_subapplications_for_funding_opportunity';

  if (programId === 47) {
    //Award subapplications tab
    if (
      statuses ==
        'subAwardAccepted,closeoutInitiated,subgrantFinancialReconciliation,subAwardOffered,closed' &&
      selector == 'get_paginated_subapps_by_subgrant_status_for_fo'
    ) {
      subappSelector = 'get_paginated_subapps_by_subgrant_status_for_fo';
    }
    //Subapplications submitted to FEMA tab
    if (
      statuses == 'submittedToFEMA,ineligible,notSelected' &&
      selector == 'get_paginated_subapplications'
    ) {
      subappSelector = 'get_paginated_subapps_submitted_to_fema_for_fmag';
    }
  }

  return fetch(
    `${ENDPOINT_SEARCH}?fundingOpportunityId=${foId}&programId=${programId}&selector=${subappSelector}&limit=${limit}&order=${order}&offset=${offset}${
      statuses ? `&statuses=${statuses}` : ''
    }${sort ? `&sort=${sort}` : ''}${
      term
        ? `&term=${encodeURIComponent(term)}${
            hideColumns ? `&hideColumns=${hideColumns}` : ''
          }`
        : ''
    }`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getPaginatedSubAwardRecs = (
  foId,
  programId,
  orgId,
  grantId,
  selector,
  limit,
  order,
  offset,
  sort,
  term,
  hideColumns
) => {
  return fetch(
    `${ENDPOINT_SEARCH}?fundingOpportunityId=${foId}&programId=${programId}&organizationId=${orgId}&grantId=${grantId}&selector=${selector}&limit=${limit}&order=${order}&offset=${offset}${
      sort ? `&sort=${sort}` : ''
    }${
      term
        ? `&term=${encodeURIComponent(term)}${
            hideColumns ? `&hideColumns=${hideColumns}` : ''
          }`
        : ''
    }`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getApplicationLinkBySubApps = (
  token,
  organizationId,
  entityType,
  subApplications
) => {
  let selector = _.isEqual(entityType, 'awardRecommendationLink')
    ? 'get_awardrecommendationlink_by_subapp'
    : 'get_applicationlink_by_subapp';
  let query =
    `organizationId=${organizationId}` +
    `&subApplications=${subApplications}` +
    `&selector=${selector}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getPaginatedAppLinks_by_parent = (
  token,
  organizationId,
  programId,
  applicationId,
  entityType,
  sort,
  sortPath,
  order,
  operation,
  field,
  offset,
  limit,
  value
) => {
  let selector = _.isEqual(entityType, 'awardRecommendationLink')
    ? 'get_awardrecommendationlinks_by_parent'
    : 'get_applicationlinks_by_parent';
  let str =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&selector=${selector}` +
    `&applicationId=${applicationId}` +
    `&sort=${sort}` +
    `&sortpath=${sortPath}` +
    `&order=${order}` +
    `&operation=${operation}` +
    `&field=${field}` +
    `&offset=${offset}` +
    `&limit=${limit}` +
    `&value=${value}`;
  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getPaginatedAppLinks_by_child = (
  token,
  organizationId,
  programId,
  applicationId,
  entityType,
  sort,
  order,
  operation,
  field,
  offset,
  limit,
  value
) => {
  let selector = _.isEqual(entityType, 'awardRecommendationLink')
    ? 'get_awardrecommendationlinks_by_child'
    : 'get_applicationlinks_by_child';
  let str =
    `organizationId=${organizationId}` +
    `&programId=${programId}` +
    `&selector=${selector}` +
    `&applicationId=${applicationId}` +
    `&sort=${sort}` +
    `&order=${order}` +
    `&operation=${operation}` +
    `&field=${field}` +
    `&offset=${offset}` +
    `&limit=${limit}` +
    `&value=${value}`;
  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRanksByApplication = (
  token,
  organizationId,
  programId,
  applicationId,
  entityType,
  limit = APPLICATION_RANK_LIMIT
) => {
  let selector = _.isEqual(entityType, 'awardRecommendationLink')
    ? 'get_awardrecommendationlink_ranks'
    : 'get_applicationlink_ranks';
  let str =
    `organizationId=${organizationId}` +
    `&selector=${selector}` +
    `&programId=${programId}` +
    `&applicationId=${applicationId}` +
    `&limit=${limit}`;
  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getFOsWithSignedAwardsSubawards = (token) => {
  let selector = 'get_fos_with_signed_awards_subawards';
  let str = `selector=${selector}`;
  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getApplicationByFOAndOrgState = (
  token,
  state,
  fundingOpportunityId,
  organizationId,
  order,
  limit
) => {
  let str =
    `state=${state}` +
    `&fundingOpportunityId=${fundingOpportunityId}` +
    `&organizationId=${organizationId}` +
    `&selector=get_applications_by_fo_and_orgState` +
    `&order=${order}` +
    `&limit=${limit}`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getEntitiesByTypeFoAndSubOrgId = (
  token,
  state,
  fundingOpportunityId,
  organizationId,
  order,
  limit,
  extraProps
) => {
  const {entityType, subOrgId, primaryAct, subAct, budgetAmount} = extraProps;
  let str =
    `fundingOpportunityId=${fundingOpportunityId}` +
    `&organizationId=${organizationId}` +
    `&entityType=${entityType}` +
    `&subOrgId=${subOrgId}` +
    `&primaryActivityType=${primaryAct}` +
    `&primarySubActivityType=${subAct}` +
    `&totalAmount=${budgetAmount}` +
    `&selector=get_entities_by_type_fo_and_subOrgId` +
    `&order=${order}` +
    `&limit=${limit}`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRFIsForAmendment = ({amendmentId, organizationId}) => {
  let str =
    `amendmentId=${amendmentId}` +
    `&organizationId=${organizationId}` +
    `&selector=get_rfi_by_amendment_and_status` +
    `&limit=1000`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRFIsForParentEntity = ({
  parentEntityId,
  organizationId,
  operation,
  field,
  fieldValue,
}) => {
  let str =
    `parentEntityId=${parentEntityId}` +
    `&organizationId=${organizationId}` +
    `&selector=get_rfi_by_parentEntity_and_status` +
    `&limit=1000`;
  if (operation && field && fieldValue)
    str = str + `&operation=${operation}&field=${field}&fieldValue=${fieldValue}`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAmendmentRecommendationLinksBySubAmendRecParent = (
  amendmentId,
  orgId,
  programId,
  status = 'initiated'
) => {
  let str =
    `limit=1000` +
    `&amendmentId=${amendmentId}` +
    `&organizationId=${orgId}` +
    `&programId=${programId}` +
    `${(status && `&status=${status}`) || ''}` +
    `&selector=get_subamendment_recommendations_by_amendment` +
    `&offset=0`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubapplicationFedShareByFundingCategory = (
  programId,
  fundingOpportunityId,
  organizationId,
  statuses
) => {
  let str =
    `programId=${programId}` +
    `&fundingOpportunityId=${fundingOpportunityId}` +
    `&organizationId=${organizationId}` +
    `&statuses=${statuses}` +
    `&selector=get_sub_applications_fed_share_by_funding_category`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubapplicationFedShareByFundingCategoryForFo = (
  programId,
  fundingOpportunityId,
  statuses
) => {
  let str =
    `programId=${programId}` +
    `&fundingOpportunityId=${fundingOpportunityId}` +
    `&statuses=${statuses}` +
    `&selector=get_sub_applications_fed_share_by_funding_category_for_funding_opportunity`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getSubawardrecommendationFedShareByFundingCategory = (
  programId,
  fundingOpportunityId,
  organizationId,
  grantId
) => {
  let str =
    `programId=${programId}` +
    `&fundingOpportunityId=${fundingOpportunityId}` +
    `&organizationId=${organizationId}` +
    `&grantId=${grantId}` +
    `&selector=get_sub_award_recommmendations_fed_share_by_funding_category`;

  return fetch(`${ENDPOINT_SEARCH}?${str}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getEntitiesForRecipientTarget = ({
  programId,
  fundingOpportunityId,
  organizationId,
  grantId,
}) => {
  let query =
    `programId=${programId}` +
    `&fundingOpportunityId=${fundingOpportunityId}` +
    `&organizationId=${organizationId}` +
    `&grantId=${grantId}` +
    `&selector=get_grant_obligation_data`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getEntitiesForAllRecipientTarget = ({fundingOpportunityId, organizationIds}) => {
  let orgIds = _.map(_.omit(organizationIds, 'loading'), (org) =>
    _.get(org, 'organizationId')
  ).join(',');
  let query =
    `fundingOpportunityId=${fundingOpportunityId}` +
    `&organizationIds=${removeEmptyIds(orgIds)}` +
    `&selector=get_fo_obligation_data`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRecipientToDoList = (
  token,
  {organizationId, organizationIds, subOrganizationIds, limit, offset, sort, order}
) => {
  let tokenValue = token;
  tokenValue = token._csrftoken;
  let query =
    `organizationIds=${organizationIds}` +
    `&subOrganizationIds=${subOrganizationIds}` +
    `&organizationId=${organizationId}` +
    `&selector=get_recipient_todo_list` +
    `&limit=${limit}` +
    `&offset=${offset}` +
    `&sort=${sort}` +
    `&order=${order}` +
    `&token=${tokenValue}`;

  return fetch(`${ENDPOINT_SEARCH}?${query}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getSubAppsByTitle,
  getSubAppsBySubapplicant,
  getSubAppsByOrgId,
  getSubAppsByOrgIdAndByCategoryId,
  getSubAppsByOrgIdAndByProgramId,
  getSubAppsBySubOrgIdAndByCategoryId,
  getSubAppsBySubOrgIdAndByProgramId,
  getSubAppsByOrgIdAndType,
  getSubAppsByOrgIdAndSubOrgId,
  getSubAppsBySubOrgIdAndOrgIdListAndByCategoryId,
  getSubAppsBySubOrgIdAndOrgIdListAndByProgramId,
  getSubAppsByOrgIdBySubOrgIdAndByCategoryId,
  getSubAppsByType,
  getSubAppsByOrgIdByTypeAndByCategoryId,
  getPaginatedEntitiesForFo,
  getPaginatedSubApps,
  getRecipientSavedForLater,
  getPaginatedSubAppsForFo,
  getPaginatedSubAwardRecs,
  getPaginatedAppLinks_by_parent,
  getPaginatedAppLinks_by_child,
  getRanksByApplication,
  getFOsWithSignedAwardsSubawards,
  getSubAppsBySubOrgIdAndOrgIdListAndByCategoryIdBothSelfAndApplicant,
  getSubAppsBySubOrgIdAndOrgIdListAndByProgramIdBothSelfAndApplicant,
  getApplicationLinkBySubApps,
  getMyGrants,
  getApplicationByFOAndOrgState,
  getEntitiesByTypeFoAndSubOrgId,
  getSubGrantsByOrgId,
  getSubGrantsBySubOrgId,
  getSubGrantsBySubOrgIdAndOrgIdList,
  getSubGrantsBySubOrgIdAndOrgIdListBothSelfAndApplicant,
  getSubGrantsBySubOrgIdAndOrgIdAndFoIdAndStatus,
  getRFIsForAmendment,
  getRFIsForParentEntity,
  getAmendmentRecommendationLinksBySubAmendRecParent,
  getSubapplicationFedShareByFundingCategory,
  getSubapplicationFedShareByFundingCategoryForFo,
  getSubawardrecommendationFedShareByFundingCategory,
  getEntitiesForRecipientTarget,
  getEntitiesForAllRecipientTarget,
  getRecipientToDoList,
};
